import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#o-nama", label: "O nama" },
  { href: "#usluge", label: "Usluge" },
  { href: "#projekti", label: "Projekti" },
  { href: "#razdjelnici", label: "Razdjelnici" },
  { href: "#kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/80 border-b border-white/10"
          : "bg-gradient-to-b from-black/60 to-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20 md:h-24">
        <a
          href="#top"
          data-testid="brand-link"
          className="flex items-center gap-3 group"
          aria-label="Electris d.o.o. — Početna"
        >
          <img
            src="/brand/electris-logo.png"
            alt="Electris d.o.o."
            className="h-12 md:h-14 w-auto object-contain drop-shadow-[0_0_18px_rgba(220,38,38,0.35)] transition-transform group-hover:scale-105"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-2">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="relative px-4 py-2 text-[15px] font-medium text-white/85 hover:text-white tracking-wide transition-colors group"
            >
              <span className="relative z-10">{l.label}</span>
              <span className="absolute left-4 right-4 -bottom-0.5 h-[2px] bg-brand origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
              <span className="absolute inset-0 bg-white/0 group-hover:bg-white/5 transition-colors duration-300" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#kontakt"
            data-testid="cta-quote-btn"
            className="hidden md:inline-flex items-center gap-2 bg-brand hover:bg-brand-light px-5 py-3 text-xs font-bold uppercase tracking-widest2 text-white transition-all hover:shadow-[0_0_30px_rgba(220,38,38,0.5)]"
          >
            Zatraži ponudu
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((s) => !s)}
            className="lg:hidden w-10 h-10 grid place-items-center border border-white/10 text-white"
            aria-label="Izbornik"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                className="text-base text-white border-l-2 border-brand pl-4 hover:text-brand-light transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-quote"
              className="mt-2 bg-brand text-white px-5 py-3 text-xs font-bold uppercase tracking-widest2 text-center"
            >
              Zatraži ponudu
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
